import { apiClient } from '@/app/core/services/apiClient.service';
import { BaseApiService } from '@/app/shared/services/apis/baseApi.service';

class EventGOSeatCategoriesApiService extends BaseApiService {
    getCategories(mainEventId) {
        return this.client.get(`main-events/${mainEventId}/guest-operations-seat-categories`);
    }

    saveCategory(mainEventId, payload) {
        return this.client.post(
            `main-events/${mainEventId}/guest-operations-seat-categories`,
            payload
        );
    }

    updateCategory(mainEventId, categoryId, payload) {
        return this.client.patch(
            `main-events/${mainEventId}/guest-operations-seat-categories/${categoryId}`,
            payload
        );
    }

    removeCategory(mainEventId, categoryId) {
        return this.client.delete(
            `main-events/${mainEventId}/guest-operations-seat-categories/${categoryId}`
        );
    }

    setForSeats(eventId, payload) {
        return this.client.post(
            `guest-operations-seat-categories/events/${eventId}/set-for-seats`,
            payload
        );
    }
}

export const eventGOSeatCategoriesApi = new EventGOSeatCategoriesApiService(apiClient);
